import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {SlideInModal} from '../../slide-in-modal'
import {AccessibilityModeButton} from '../accessibility-mode-button'
import {EventInfo} from '../event-info'
import {Summary} from '../summary'
import {SummaryContainer} from '../summary-container'
import {Ticket} from '../ticket'
import {TicketsListContainer} from '../tickets-list-container'
import {classes} from './tickets.st.css'
import {TicketsProps} from './index'

export const Tickets = ({
  show,
  placesInBasket,
  showAccessibilityMode,
  onBackClick,
  onRemoveClick,
  onCheckoutClick,
  onTicketMoreInfoClick,
  chooseSeatMode,
  chooseMultipleSeatsMode,
  placesInBasketCount,
  setForcedPopover,
}: TicketsProps) => {
  const {isMobile} = useEnvironment()
  const {t} = useTranslation()
  const desktop = !isMobile

  return (
    <SlideInModal
      id="tickets"
      dataHook={DH.SEATING_BASKET}
      backButtonText={showAccessibilityMode ? t('seatings_backToList') : t('seatings_backToMap')}
      show={show}
      animations={false}
      onBackClick={onBackClick}
      focus={DH.EVENT_INFO}
      circularFocus={placesInBasketCount ? DH.REMOVE_TICKET : DH.ACCESSIBILITY_MODE_BUTTON}
      immediate={isMobile}
    >
      {!chooseSeatMode && !chooseMultipleSeatsMode && <EventInfo />}
      {!chooseSeatMode && !chooseMultipleSeatsMode && (
        <Text className={classes.title} tagName="h2">
          {t('seating_basketCount', {count: placesInBasketCount})}
        </Text>
      )}
      {desktop && !placesInBasketCount ? (
        <Text
          className={classNames(classes.subtitle, {
            [classes.subtitlePaddingTop]: chooseSeatMode || chooseMultipleSeatsMode,
          })}
          tagName="p"
        >
          {t('seatings_tickets_emptyState_description')}
        </Text>
      ) : null}
      <TicketsListContainer
        chooseSeatMode={chooseSeatMode}
        chooseMultipleSeatsMode={chooseMultipleSeatsMode}
        basketView
      >
        {isMobile && !placesInBasketCount ? (
          <Text className={classes.mobileEmptyState}>{t('seatings_tickets_emptyState_description')}</Text>
        ) : null}
        {placesInBasket.map((place, index) => (
          <Ticket
            key={`${index}-${place.id}`}
            place={place}
            onRemoveClick={onRemoveClick}
            onTicketMoreInfoClick={onTicketMoreInfoClick}
            setForcedPopover={setForcedPopover}
            basketView={true}
          />
        ))}
      </TicketsListContainer>
      {desktop ? <AccessibilityModeButton /> : null}
      {!chooseSeatMode && !chooseMultipleSeatsMode && (
        <SummaryContainer inTickets={true}>
          <Summary inTickets={true} onCheckoutClick={onCheckoutClick} onBackClick={onBackClick} />
        </SummaryContainer>
      )}
    </SlideInModal>
  )
}
